import Offer from '../models/offer';
import _ from "@helpers/_";

export default class Resource {

  constructor(data) {

    this.properties = data.properties;
    this.categories = data.categories;
    this.created_at = data.created_at;
    this.id = data.id;
    this.images = data.images;
    this.name = data.name;
    this.offers = data.offers;
    this.updated_at = data.updated_at;
    this.user = data.user;
    this.user_id = data.user_id;
    this.pendingUploads = 0;
    this.diplay_offers = [];

    if (this.offers) {
      this.offers = this.offers.map((offer) => {
        // console.log(offer);
        // offer.group_ids = ['sssss'];
        return new Offer(offer);
      });

      this.diplay_offers = this.offers.filter(o => o.status === 'open');
    }
  }

  // preview() {
  //   if (this.preview) {
  //     return this.preview;
  //   } else {
  //     return null;
  //   }
  // }

  isOpen() {
    return this.offers.map(offer => offer.status).filter(status => status === 'open').length > 0;
  }


  image(index) {
    // debugger
    index = index || 0;
    if (this.images && this.images[index]) {
      if (this.images[index].cdn) {
        // debugger
        return this.images[index].cdn.replace('.png', '.jpg').replace('upload/v', 'upload/c_scale,q_90,w_400/v');
        // return this.images[index].cdn.replace('.png', '.jpg');
      } else {
        return this.images[index].storage;
      }
    } else {
      return null;
    }
  }

  bigImage(index) {
    // debugger
    index = index || 0;
    if (this.images && this.images[index]) {
      if (this.images[index].cdn) {
        // debugger
        return this.images[index].cdn.replace('.png', '.jpg').replace(/upload.*\/v/, 'upload/c_scale,q_90,w_400/v');
        // return this.images[index].cdn.replace('.png', '.jpg');
      } else {
        return this.images[index].storage;
      }
    } else {
      return null;
    }
  }

  smallImage(index) {
    // debugger
    index = index || 0;
    if (this.images && this.images[index]) {
      if (this.images[index].cdn) {
        // return this.images[index].cdn.replace('.png', '.jpg').replace(/upload.*\/v/, 'upload/c_scale,q_90,w_200/v');
        return this.images[index].cdn.replace('.png', '.jpg').replace(/upload.*\/v/, 'upload/ar_1:1,c_fill,dl_0,f_jpg,fl_lossy.no_overflow.no_stream,q_auto:low,w_400/v');


        // http://res.cloudinary.com/du8gpvdbl/image/upload/ar_1:1,c_fill,dl_0,f_jpg,fl_lossy.no_overflow.no_stream,q_auto:low,w_400/v1525597622/0-1525597620920.jpg
      } else {
        return this.images[index].storage;
      }
    } else {
      return null;
    }
  }

  tinyImage(index) {
    // debugger
    index = index || 0;
    if (this.images && this.images[index]) {
      if (this.images[index].cdn) {
        // debugger
        return this.images[index].cdn.replace('.png', '.jpg').replace(/upload.*\/v/, 'upload/c_scale,q_90,w_10/v');
        // return this.images[index].cdn.replace('.png', '.jpg');
      } else {
        return this.images[index].storage;
      }
    } else {
      return null;
    }
  }

  isEqual(resource) {
    if (typeof resource !== "Resource") {
      resource = new Resource(resource);
    }

    return _.isEqual(this, resource);
  }

  displayedOffers() {
    return this.offers.filter(o => o.status !== 'deleted');
  }

  hasOffers() {
    return Boolean(this.displayedOffers().length);
  }

  // toJson() {
  //   return {
  //     categories: this.categories.map(category => category),
  //     created_at: this.created_at,
  //     id: this.id,
  //     images: this.images.map(image => image),
  //     name: this.name,
  //     properties: this.properties,
  //     updated_at: this.updated_at,
  //     offers: this.offers.map(offer => offer.toJson()),
  //   };
  // }

}
